/**
 * Reglas de la contrasena en vivo. Replica la politica que valida el servidor
 * (`PasswordService.check`) para que la persona vea que le falta antes de
 * enviar, pero la comprobacion que manda sigue siendo la del backend.
 */
export interface PasswordRule {
  label: string;
  test: (password: string) => boolean;
}

export const PASSWORD_RULES: PasswordRule[] = [
  { label: 'Al menos 8 caracteres', test: (p) => p.length >= 8 },
  { label: 'Una letra mayuscula', test: (p) => /[A-Z]/.test(p) },
  { label: 'Una letra minuscula', test: (p) => /[a-z]/.test(p) },
  { label: 'Un numero', test: (p) => /[0-9]/.test(p) },
  { label: 'Un simbolo (!@#$%&*)', test: (p) => /[^A-Za-z0-9]/.test(p) },
];

export function meetsPolicy(password: string): boolean {
  return PASSWORD_RULES.every((rule) => rule.test(password));
}

export function PasswordChecklist({ password }: { password: string }) {
  return (
    <ul className="grid gap-1.5 text-[11.5px] sm:grid-cols-2" aria-label="Requisitos de la contrasena">
      {PASSWORD_RULES.map((rule) => {
        const passed = rule.test(password);
        return (
          <li
            key={rule.label}
            className={`flex items-center gap-1.5 ${passed ? 'text-success' : 'text-faint'}`}
          >
            <span
              aria-hidden="true"
              className={`flex size-[14px] flex-none items-center justify-center rounded-[4px] text-[9px] ${
                passed
                  ? 'border border-success bg-success text-white'
                  : 'border-[1.5px] border-line-dashed text-transparent'
              }`}
            >
              ✓
            </span>
            <span>{rule.label}</span>
            <span className="sr-only">{passed ? ' (cumplido)' : ' (pendiente)'}</span>
          </li>
        );
      })}
    </ul>
  );
}
